import {SectionBgView} from '../../ui_canvas_engine/SectionBgView'
import {PIXI} from '@colonist/pixi'
import {TextView} from '../../ui_canvas_engine/TextView'
import {GameColor} from '../../GameColor'
import {GameFont} from '../../GameFont'
import {SpriteView} from '../../ui_canvas_engine/SpriteView'
import {EndGameData} from '@colonist/game-base-types'
import {TranslationObject} from '@colonist/i18n'
import {SectionView} from '../../ui_canvas_engine/SectionView'
import {Sprites} from '../UIGameImageDictionary'
import {UIGameSpriteHandler} from '../../UIGameSpriteHandler'
import {UIUtilsEjsVariables} from '../../UIUtilsEjsVariables'

export class UIGameEndTableView extends SectionBgView {
    private readonly textsToHideWhenInactive: PIXI.Container
    private readonly columnWidth: number
    private readonly rowHeight: number

    constructor(x: number, y: number, w: number, h: number, container: PIXI.Container, columnWidth: number, rowHeight: number) {
        super(x, y, w, h, container)
        this.textsToHideWhenInactive = new SectionView(0, 0, w, h, this)
        this.columnWidth = columnWidth
        this.rowHeight = rowHeight
    }

    createPoints(players: EndGameData[][]) {
        let nowY = 0
        for(const playerData of players) {
            let nowX = 0
            let isVPText = true
            for(const data of playerData) {
                const color = data.green ? GameColor.Color.GreenDark : data.red ? GameColor.Color.RedDark : undefined
                const text: TranslationObject = {key: 'strings:colonistCommon.utils.#buffer', options: {value: data.amount}}
                this.printOverviewResult(nowX, nowY, this.columnWidth, text, data.highest, color, isVPText)
                nowX += this.columnWidth
                isVPText = false
            }
            nowY += this.rowHeight
        }
    }

    private printOverviewResult(x: number, y: number, size: number, text: TranslationObject, highlight: boolean, color: GameColor.Color | undefined, isVPText: boolean) {
        const container = isVPText ? this : this.textsToHideWhenInactive
        if(highlight) new SpriteView(x, y, size, size, container, UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.icon_highlight_circle))
        const displayColor = GameColor.getColor(color ?? GameColor.Color.Gray3)
        const vpTextSize = UIUtilsEjsVariables.isUserOnMobileApp ? GameFont.Size.XL : GameFont.Size.XXL
        const defaultTextSize = UIUtilsEjsVariables.isUserOnMobileApp ? GameFont.Size.L : GameFont.Size.XL
        const textSize = isVPText ? vpTextSize : defaultTextSize
        const textView = new TextView(text, x, y, size, size, container, textSize, displayColor)
        if(color != undefined) textView.makeBold()
        textView.centerX()
    }

    show() {
        this.addChild(this.textsToHideWhenInactive)
    }

    hide() {
        this.removeChild(this.textsToHideWhenInactive)
    }
}
